import { Clipboard } from '@angular/cdk/clipboard';
import { Component, Inject, Input } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AdobeTrackingService } from '@datev/ngx-adobe-tracking';
import { take } from 'rxjs';
import {
  AdobeTrackingActions,
  Download,
  isMainRelease,
  isPackage,
  isProduct,
  isServiceRelease,
} from '../../model';
import { ActiveFeedbackService } from '../../shared/services/active-feedback.service';
import { DownloadService } from '../../shared/services/download.service';
import { NgClass, DatePipe } from '@angular/common';
import { MatButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';
import { FileSizePipe } from '../../shared/pipes/file-size.pipe';
@Component({
    selector: 'download-info-card',
    templateUrl: './download-info-card.component.html',
    styleUrl: './download-info-card.component.scss',
    imports: [
        NgClass,
        MatButton,
        MatTooltip,
        MatIcon,
        DatePipe,
        FileSizePipe,
    ],
})
export class DownloadInfoCardComponent {
  @Input() downloadInformation!: Download;
  @Input() showTeaser: boolean = true;
  @Input() enableHorizontalDisplay: boolean = true;

  constructor(
    private readonly clipboard: Clipboard,
    private readonly snackBar: MatSnackBar,
    private readonly downloadService: DownloadService,
    @Inject('Window') private readonly window: Window,
    private readonly adobeTrackingService: AdobeTrackingService,
    private readonly activeFeedbackService: ActiveFeedbackService,
  ) {}

  copyToClipboard(content: string | undefined): void {
    if (content && this.clipboard.copy(content)) {
      this.snackBar.open('Prüfsumme in die Zwischenablage kopiert', '', {
        duration: 3000,
      });
    }
  }

  startDownload(download: Download): void {
    const adobeTrackingPoint = this.getAdobeTrackingPoint(download);

    if (adobeTrackingPoint !== '') {
      this.adobeTrackingService.publishClickEvent(adobeTrackingPoint);
    }

    this.downloadService
      .getDownloadLink(download.id)
      .pipe(take(1))
      .subscribe({
        next: downloadUrl => {
          this.window.open(downloadUrl, '_blank');
          this.activeFeedbackService.showFeedbackDialog();
        },
      });
  }

  private getAdobeTrackingPoint(download: Download): string {
    if (isPackage(download)) {
      return AdobeTrackingActions.DOWNLOAD_BASE_SOFTWARE;
    }
    if (isProduct(download)) {
      return AdobeTrackingActions.DOWNLOAD_ADDITIONAL_SOFTWARE;
    }
    if (isMainRelease(download)) {
      return AdobeTrackingActions.DOWNLOAD_MAIN_RELEASE;
    }
    if (isServiceRelease(download)) {
      return AdobeTrackingActions.DOWNLOAD_SERVICE_RELEASE;
    }

    return '';
  }
}
